import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ArrowRight, X, Loader2 } from 'lucide-react';
const features = ['Módulo Master: Inteligencia Artificial', 'Módulo Master: Ventas Digitales', 'Módulo Master: Trading Institucional', 'Comunidad Privada de Alumnos', 'Soporte y Sesiones Q&A'];
function LeadModal({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await fetch('https://formsubmit.co/ajax/andrescastro471@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          'Nombre Completo': formData.name,
          Teléfono: formData.phone,
          'Correo Electrónico': formData.email,
          _subject: 'Nueva solicitud — Guía 1K'
        })
      });
    } catch {
      // Still show success to user
    }
    setIsSubmitting(false);
    setIsSuccess(true);
  };
  return <AnimatePresence data-id="element-91">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-92">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-md glass-card rounded-2xl border border-brand-cyan/30 overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-93">
            <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-94">
              <h3 className="font-display text-xl font-bold text-white" data-id="element-95">
                Obtén tu Guía 1K Gratis
              </h3>
              <button onClick={onClose} className="w-8 h-8 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-white/60 hover:text-white transition-colors" data-id="element-96">
                <X className="w-4 h-4" data-id="element-97" />
              </button>
            </div>

            <div className="p-6" data-id="element-98">
              {isSuccess ? <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-center py-8" data-id="element-99">
                  <div className="w-16 h-16 rounded-full bg-brand-cyan/20 flex items-center justify-center mx-auto mb-4" data-id="element-100">
                    <Check className="w-8 h-8 text-brand-cyan" data-id="element-101" />
                  </div>
                  <h4 className="text-xl font-bold text-white mb-2" data-id="element-102">
                    ¡Solicitud Recibida!
                  </h4>
                  <p className="text-white/60" data-id="element-103">
                    Processing time about 12h to 24h
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-104">
                  <div data-id="element-105">
                    <label className="block text-sm font-medium text-white/80 mb-1.5" data-id="element-106">
                      Nombre Completo
                    </label>
                    <input type="text" required value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-white/30 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="Tu nombre" data-id="element-107" />
                  </div>
                  <div data-id="element-108">
                    <label className="block text-sm font-medium text-white/80 mb-1.5" data-id="element-109">
                      Teléfono
                    </label>
                    <input type="tel" required value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-white/30 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="+1 (555) 000-0000" data-id="element-110" />
                  </div>
                  <div data-id="element-111">
                    <label className="block text-sm font-medium text-white/80 mb-1.5" data-id="element-112">
                      Correo Electrónico
                    </label>
                    <input type="email" required value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder:text-white/30 focus:outline-none focus:border-brand-cyan focus:ring-1 focus:ring-brand-cyan transition-all" placeholder="tu@email.com" data-id="element-113" />
                  </div>

                  <button type="submit" disabled={isSubmitting} className="w-full mt-6 group relative inline-flex items-center justify-center gap-3 px-8 py-4 rounded-xl bg-brand-cyan text-black font-bold text-lg transition-all duration-300 btn-glow-cyan hover:bg-brand-cyan/90 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-114">
                    {isSubmitting ? <Loader2 className="w-5 h-5 animate-spin" data-id="element-115" /> : <>
                        <span className="relative z-10" data-id="element-116">Obtener Guía 1K</span>
                        <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-117" />
                      </>}
                  </button>
                </form>}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Pricing() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="cta" className="py-12 relative z-10" data-id="element-118">
      <div className="max-w-4xl mx-auto px-6" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="glass-card rounded-3xl p-1 md:p-2 relative" data-id="element-120">
          {/* Outer glow */}
          <div className="absolute -inset-0.5 bg-gradient-to-b from-brand-cyan/30 to-transparent rounded-3xl blur opacity-30" data-id="element-121" />

          <div className="relative bg-brand-dark/80 backdrop-blur-xl rounded-[22px] md:rounded-[30px] p-8 md:p-12 border border-white/5 flex flex-col md:flex-row gap-12 items-center" data-id="element-122">
            <div className="flex-1 text-center md:text-left" data-id="element-123">
              <div className="inline-block px-4 py-1.5 rounded-full bg-brand-cyan/10 border border-brand-cyan/20 text-brand-cyan text-sm font-medium mb-6" data-id="element-124">
                🔥 Oferta de Lanzamiento
              </div>

              <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-125">
                Acceso al Sistema Completo
              </h2>

              <div className="mb-8 p-4 rounded-xl bg-white/5 border border-white/10" data-id="element-126">
                <p className="text-white/80 font-medium text-lg" data-id="element-127">
                  Under Construction 🚧
                </p>
                <p className="text-white/60 text-sm mt-1" data-id="element-128">
                  Trabajando en la comunidad y los módulos
                </p>
              </div>

              <button onClick={() => setIsModalOpen(true)} className="w-full group relative inline-flex items-center justify-center gap-3 px-8 py-4 rounded-xl bg-brand-cyan text-black font-bold text-lg transition-all duration-300 btn-glow-cyan hover:bg-brand-cyan/90 overflow-hidden" data-id="element-129">
                <span className="relative z-10" data-id="element-130">Obtén Guía 1K Gratis</span>
                <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-131" />
              </button>
              <p className="text-center text-brand-cyan/80 font-medium text-sm mt-4" data-id="element-132">
                Por tiempo limitado
              </p>
            </div>

            <div className="flex-1 w-full md:border-l md:border-white/10 md:pl-12" data-id="element-133">
              <ul className="space-y-4" data-id="element-134">
                {features.map((feature, index) => <motion.li key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2 + index * 0.1
              }} className="flex items-start gap-3" data-id="element-135">
                    <div className="mt-1 w-5 h-5 rounded-full bg-brand-cyan/20 flex items-center justify-center shrink-0" data-id="element-136">
                      <Check className="w-3 h-3 text-brand-cyan" data-id="element-137" />
                    </div>
                    <span className="text-white/80" data-id="element-138">{feature}</span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>

      <LeadModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-139" />
    </section>;
}